import React, { useState, useEffect } from "react";
import api from "@api";
import { Form } from "@components";
import { InfrastructureModel } from "@api/types/infrastructure";
import { InfrastructureDetail } from "./detail";
import { M_TABLE_HEADERS_INFRASTRUCTURE } from "../constants";
import { Cell } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import { FilterType, Table } from "@components";
import { useInfraStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportInfrastructures } from "@api/excel-exporters/exportInfrastructures";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.TYPE_NAME },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.IS_ACTIVE },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.WITH_APP_NAME },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.APPROVER2 },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.APPROVER3 },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.APPROVER4 },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.APPROVER_DISTRO_2 },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.APPROVER_DISTRO_3 },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.APPROVER_DISTRO_4 },
  { data: M_TABLE_HEADERS_INFRASTRUCTURE.BUSINESS_UNIT },
];

export const Infrastructure: React.FC = () => {
  const [infraStore, setInfraStore] = useInfraStore();

  useEffect(() => {
    if (infraStore.fetchList) {
      getDataList();
    }
  }, [infraStore]);

  const form = Form.useManager<InfrastructureModel>({
    // infrastructure name
    id: 0,
    typeName: "",
    isActive: false,
    isWithAppName: false,
    approver1: "",
    approver2: "",
    approver3: "",
    approver4: "",
    approverDistro2: 0,
    approverDistro3: 0,
    approverDistro4: 0,
    // business unit
    systemType: "",
    metaData: "",
    uamNote: "",
    assignmentTeam: "",
    accessDetailNote: "",
    isProvoRequest: false,
  });

  const [openInfra, setOpenInfra] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedInfra, setSelectedInfra] = useState<any>({});
  const [infraList, setInfraList] = useState<any>([]);

  useEffect(() => {
    getDataList();
  }, []);

  function getDataList() {
    api.infrastructure
      .getInfra()
      .then((response) => {
        // console.log(response.infrastructures);
        setInfraList(response.infrastructures);
      })
      .catch((error) => {
        // console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
        setInfraStore({ fetchList: false });
      });
  }

  useEffect(() => {
    if (openInfra) {
      if (selectedInfra) {
        form.set(Form.target.VALUE, ["id", selectedInfra.id]);
        form.set(Form.target.VALUE, ["typeName", selectedInfra.typeName]);
        // console.log(selectedInfra);
        form.set(Form.target.VALUE, [
          "isWithAppName",
          selectedInfra.isWithAppName,
        ]);
        form.set(Form.target.VALUE, ["approver1", selectedInfra.approver1]);
        form.set(Form.target.VALUE, ["approver2", selectedInfra.approver2]);
        form.set(Form.target.VALUE, ["approver3", selectedInfra.approver3]);
        form.set(Form.target.VALUE, ["approver4", selectedInfra.approver4]);
        form.set(Form.target.VALUE, [
          "approverDistro2",
          selectedInfra.approver2DistroId,
        ]);
        form.set(Form.target.VALUE, [
          "approverDistro3",
          selectedInfra.approver3DistroId,
        ]);
        form.set(Form.target.VALUE, [
          "approverDistro4",
          selectedInfra.approver4DistroId,
        ]);
        form.set(Form.target.VALUE, ["systemType", selectedInfra.systemType]);
        form.set(Form.target.VALUE, ["metaData", selectedInfra.metaData]);
        form.set(Form.target.VALUE, ["uamNote", selectedInfra.uamNote]);
        form.set(Form.target.VALUE, [
          "assignmentTeam",
          selectedInfra.assignmentTeam,
        ]);
        form.set(Form.target.VALUE, [
          "accessDetailNote",
          selectedInfra.accessDetailNote,
        ]);
        form.set(Form.target.VALUE, ["isActive", selectedInfra.isActive]);
        form.set(Form.target.VALUE, [
          "isProvoRequest",
          selectedInfra.isProvoRequest,
        ]);
      }
    }
  }, [openInfra]);

  function checkForNullName(data: any) {
    if (!data) return "";
    return data.name;
  }

  const isShowModal = openInfra ? (
    <InfrastructureDetail
      form={form}
      open={openInfra}
      onCancel={() => setOpenInfra(false)}
    />
  ) : (
    ""
  );

  function handleExport() {
    exportInfrastructures();
  }

  const pageName = "Infrastructures";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <Table
        data={infraList.map((infra: any) => ({
          cells: [
            {
              data: infra.typeName,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedInfra(infra);
                setOpenInfra(true);
              },
            },
            {
              data: infra.isActive ? "Yes" : "No",
            },
            {
              data: infra.isWithAppName ? "Yes" : "No",
            },
            {
              data: infra.approver2,
            },
            {
              data: infra.approver3,
            },
            {
              data: infra.approver4,
            },
            {
              data: checkForNullName(infra.approver2Distro),
            },
            {
              data: checkForNullName(infra.approver3Distro),
            },
            {
              data: checkForNullName(infra.approver4Distro),
            },
            {
              data: infra.systemType,
            },
          ],
          data: infra,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Type Name"
        searchColumns={[M_TABLE_HEADERS_INFRASTRUCTURE.TYPE_NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_INFRASTRUCTURE_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
